import { forwardRef } from "react";
function SvgRawWarningIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={20}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#1D1D1D"
        d="m15.608.9 5.39 5.386.004 7.62-5.386 5.39-7.62.004-5.391-5.386-.003-7.62L7.988.904 15.608.9Z"
        opacity={0.25}
      />
      <path
        fill="#fff"
        d="m13.608 1.4 5.39 5.386.004 7.62-5.386 5.39-7.62.004-5.391-5.386-.003-7.62 5.386-5.39 7.62-.004Z"
      />
      <path
        fill="#DD3636"
        fillRule="evenodd"
        d="M9 6.5a1.1 1.1 0 1 1 2.2 0v5a1.1 1.1 0 1 1-2.2 0v-5ZM9 15.1a.9.9 0 0 1 .9-.9h.4a.9.9 0 0 1 0 1.8h-.4a.9.9 0 0 1-.9-.9Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawWarningIcon);
export default ForwardRef;
